import React from "react";
import { IconWrapper } from "./Icon.styles";
import { IconProps } from "./Icon.types";

export const Icon = ({ name, onClick, ...props }: IconProps) => {
  return (
    <IconWrapper onClick={onClick} {...props} data-cy={props.dataCy}>
      <i className={name}></i>
    </IconWrapper>
  );
};
